'use strict';

var defaultTheme = require('./defaultTheme.js');
var withTheme$2 = require('../../../styles/esm/withTheme/withTheme.js');

var withTheme = withTheme$2.withThemeCreator({
  defaultTheme: defaultTheme
});
var withTheme$1 = withTheme;

module.exports = withTheme$1;
